import { AxiosError } from 'axios'

export const verifyIfIsInMaintenance = (error: AxiosError) => {
  const errorStatus = error.response?.status

  if (errorStatus === 503 && typeof window !== 'undefined') {
    if (window.location.pathname === '/503') return
    return (window.location.href = `/503`)
  }

  return Promise.reject(error)
}
